import { Helmet } from 'react-helmet-async'
import { useI18n } from '../i18n'

const SITE_NAME = 'QR Tool'
const BASE_URL = 'https://qr.masterlevel.de'

interface Props {
  title: string
  description: string
  path?: string
}

export function Meta({ title, description, path = '' }: Props) {
  const { locale } = useI18n()
  const fullUrl = BASE_URL + path

  return (
    <Helmet>
      <html lang={locale} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  )
}
